<template>
  <div>
    <Layout v-if="isLoadingDoc">
      <div class="layout__wrapper">
        <loading-spinner />
      </div>
    </Layout>

    <router-view v-if="doc" :doc="doc"></router-view>

    <Layout v-if="!doc && isErrorLoadingDoc">
      <div class="layout__wrapper">
        <LoadingError />
      </div>
    </Layout>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount } from 'vue'

import { DocView } from '@/models/doc'
import Layout from '@/app/components/Layout.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'

const props = defineProps<{
  doc: DocView | null
  isLoadingDoc: boolean
  isErrorLoadingDoc: boolean
}>()

onBeforeUnmount(() => {
  if (props.doc && props.doc.readingProgress) {
    props.doc.readingProgress.destroy()
  }
})
</script>
